import { YieldAction } from '@/features/assets/constants'
import { createClient } from '@/shared/api/client'
import { buildUrl } from '@/shared/utils/urls'
import { TargetSystem } from '@/shared/constants'
import { validateResponseIsOk } from '@/shared/api/validation'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export async function actionYield(assetCode: string, action: YieldAction) {
  await validateResponseIsOk(
    client.sendPut(
      `assets/${assetCode}/yields/actions`,
      {
        data: { action }
      }
    )
  )
}
